import React from "react";
import WarehouseEntryForm from "./Components/WarehouseEntryForm";

const Edit = (props) => {
    return (
        <div className="space-y-6">
            <WarehouseEntryForm {...props} initialState={props.entry} />
        </div>
    );
};

export default Edit;
